(function () {
  var host = document.querySelector('.disuri-newsletter-klaviyo[data-klaviyo-form-id]');
  if (!host) return;

  var formId = host.getAttribute('data-klaviyo-form-id');
  var redirectUrl = host.getAttribute('data-success-url');
  if (!formId || !redirectUrl) return;

  function handleKlaviyoFormEvent(event) {
    var detail = event && event.detail;
    if (!detail || detail.formId !== formId || detail.type !== 'submit') return;
    window.location.assign(redirectUrl);
  }

  window.addEventListener('klaviyoForms', handleKlaviyoFormEvent);
})();
